import React, { useState } from "react";

function StatusTabStay({ title, data, isFullWith, height, roomNights = {}, checkOutNextDay = "", updateStatusTabArray }) {
    const [isEditing, setIsEditing] = useState(false);
    const rooms = String(data || "").split(",").map(room => room.trim()).filter(Boolean);
    const nightsByRoom = new Map(Object.entries(roomNights));
    const checkOutNextDaySet = new Set(
        String(checkOutNextDay || "").split(",").map(room => room.split("(")[0].trim()).filter(Boolean)
    );

    function getRoomMarker(room) {
        const nights = nightsByRoom.get(room);
        if (nights > 0 && nights % 3 === 0) return "circle";
        if (checkOutNextDaySet.has(room)) return "none";
        if (nights > 0 && (nights + 1) % 3 === 0) return "square";
        return "none";
    }

    const hasMarkedRooms = rooms.some(room => getRoomMarker(room) !== "none");

    function sortRoomList(value) {
        const sortedRooms = value.split(",").map(room => room.trim()).filter(Boolean);

        const getSortValue = room => {
            const firstCharacter = room.replace(" ", "").slice(0, 1);
            if (!Number.isNaN(Number(firstCharacter))) {
                const leadingNumber = room.replace(" ", "").slice(0, 3);
                return Number.isNaN(Number(leadingNumber)) ? 0 : Number(leadingNumber);
            }

            const followingNumber = room.replace(" ", "").slice(1, 3);
            return Number.isNaN(Number(followingNumber)) ? 0 : Number(followingNumber);
        };

        sortedRooms.sort((a, b) => getSortValue(a) - getSortValue(b));
        updateStatusTabArray("listGuestStay", sortedRooms.join(","));
    }

    return (
        <div className="checkout" style={{ width: isFullWith ? "100%" : "600px" }}>
            <div
                className="d-flex align-items-center justify-content-between"
                style={{
                    border: "1px solid black",
                    fontWeight: "600",
                    backgroundColor: "rgb(194 246 139 / 43%)",
                    padding: "4px",
                }}
            >
                <span>{title}</span>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary no-print"
                    onClick={() => setIsEditing(editing => !editing)}
                >
                    {isEditing ? "Xong" : "Sửa danh sách"}
                </button>
            </div>

            <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "1px", border: "1px solid black",}}
            >
                {/*  minHeight: height  */}
                {rooms.length > 0 ? rooms.map((room, index) => {
                    const nightsStayed = nightsByRoom.get(room);
                    const marker = getRoomMarker(room);
                    const isCircled = marker === "circle";
                    return (
                        <span
                            key={`${room}-${index}`}
                            title={nightsStayed !== undefined ? `${nightsStayed} ngày lưu trú, tính cả ngày check-in đến ngày làm Glist` : "Chưa có ngày check-in để tính số ngày"}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: "35px",
                                minHeight: "35px",
                                padding: "4px 6px",
                                border: isCircled ? "2px solid #d9534f" : marker === "square" ? "1px solid #777" : "0",
                                borderRadius: isCircled ? "50%" : marker === "square" ? "6px" : "0",
                                color: isCircled ? "#b52b27" : "inherit",
                                fontWeight: isCircled ? "600" : "normal",
                            }}
                        >
                            {`${room}`}
                        </span>
                    );
                }) : <span>Không có phòng</span>}
            </div>
            {/*  (${nightsStayed !== undefined ? nightsStayed : "?"}) */}

            {hasMarkedRooms && (
                <div style={{ color: "#b52b27", padding: "4px 8px",border: "1px solid black" }}>
                    Tính cả ngày check-in: tròn khi số ngày hôm nay chia hết cho 3;
                    vuông khi ngày mai chia hết cho 3 và không check-out ngày mai.
                    Phòng tròn đỏ vẫn giữ viền dù check-out ngày mai. 
                </div>
            )}

            {isEditing && (
                <textarea
                    aria-label="Chỉnh sửa danh sách phòng ở"
                    style={{
                        display: "block",
                        width: "100%",
                        minHeight: height,
                        letterSpacing: "2px",
                    }}
                    value={String(data || "")}
                    onChange={event => updateStatusTabArray("listGuestStay", event.target.value)}
                    onBlur={event => sortRoomList(event.target.value)}
                />
            )}

            <div
                style={{
                    textAlign: "left",
                    fontWeight: "600",
                    border: "1px solid black",
                    height: "31px",
                }}
            >
                <label className="ml-3">Tổng:</label>
                <input
                    aria-label="Tổng số phòng ở"
                    readOnly
                    style={{
                        width: "50px",
                        border: "unset",
                        height: "17px",
                        marginLeft: "8px",
                    }}
                    value={rooms.length}
                />
            </div>
        </div>
    );
}

export default StatusTabStay;
